<div>
  {{ "TAKEOVER_ACTION_FROM" | translate: { user: user() ?? "unknown" } | capitalize }}
</div>
<div>
  {{ details() }}
</div>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button kendoButton  class="g-start-10" [themeColor]="'primary'" (click)="openAsReadOnly()">
      {{ "OPEN_AS_READONLY" | translate | capitalize }}
    </button>
    <button class="g-col-2 g-start-11 bgc-accents-red-500 fc-base-white" kendoButton (click)="accept()" [themeColor]="'primary'">
      {{ "TAKE_OVER" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
